import {
  ACTIONFORM_FETCHITEM_LOAD,
  ACTIONFORM_FETCHITEM_SUCCEED,
  ACTIONFORM_FETCHITEM_FAIL,
  ACTIONFORM_EDITFORM_CHANGE,
  ACTIONFORM_ENTER_RESET,
  ACTIONFORM_CREATEITEM_LOAD,
  ACTIONFORM_CREATEITEM_SUCCEED,
  ACTIONFORM_CREATEITEM_FAIL,
  ACTIONFORM_EDITITEM_LOAD,
  ACTIONFORM_EDITITEM_SUCCEED,
  ACTIONFORM_EDITITEM_FAIL,
  ACTIONFORM_DELETEITEM_LOAD,
  ACTIONFORM_DELETEITEM_SUCCEED,
  ACTIONFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ACTIONFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case ACTIONFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case ACTIONFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case ACTIONFORM_ENTER_RESET:
      return {}
    case ACTIONFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case ACTIONFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case ACTIONFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case ACTIONFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case ACTIONFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case ACTIONFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case ACTIONFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case ACTIONFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case ACTIONFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case ACTIONFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/actionForm.js